module.exports = __webpack_public_path__ + "img/follow-header.c65fff35.png";